import { render, staticRenderFns } from "./UploadFileDialog.vue?vue&type=template&id=04770cad&"
import script from "./UploadFileDialog.vue?vue&type=script&lang=js&"
export * from "./UploadFileDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports